import axios from 'axios'
import { Promotion } from '../../interfaces/promotion'

export const deletePromotion = (promotion: Promotion) => {
  return axios.delete('/data/sadarbības_partnera_akcija/' + promotion.id)
}
